/**
 * Utilitaires pour l'affichage standardisé des numéros de téléphone
 */

/**
 * Formate un numéro de téléphone pour l'affichage avec préfixe
 * @param {string} phone - Le numéro de téléphone
 * @param {string} phonePrefix - Le préfixe téléphonique (ex: "+33")
 * @param {string} defaultPrefix - Le préfixe par défaut si aucun n'est fourni (défaut: "+33")
 * @param {string} fallbackText - Texte à afficher si pas de téléphone (défaut: "Non renseigné")
 * @returns {string} - Le téléphone formaté ou le texte de fallback
 */
export const formatPhoneDisplay = (phone, phonePrefix = null, defaultPrefix = '+33', fallbackText = 'Non renseigné') => {
  // Si pas de numéro, retourner le texte de fallback
  if (!phone || phone.trim() === '') {
    return fallbackText;
  }

  // Utiliser le préfixe fourni ou le préfixe par défaut
  const prefix = phonePrefix || defaultPrefix;
  
  // Retourner le format standardisé avec espace
  return `${prefix} ${phone.trim()}`;
};

/**
 * Formate un numéro de téléphone pour l'affichage compact (sans espace)
 * Utile pour les liens tel: ou les APIs
 * @param {string} phone - Le numéro de téléphone
 * @param {string} phonePrefix - Le préfixe téléphonique
 * @param {string} defaultPrefix - Le préfixe par défaut
 * @returns {string} - Le téléphone formaté sans espace ou chaîne vide
 */
export const formatPhoneCompact = (phone, phonePrefix = null, defaultPrefix = '+33') => {
  if (!phone || phone.trim() === '') {
    return '';
  }

  const prefix = phonePrefix || defaultPrefix;
  return `${prefix}${phone.trim()}`;
};

/**
 * Vérifie si un numéro de téléphone est disponible
 * @param {string} phone - Le numéro de téléphone
 * @returns {boolean} - True si le téléphone est disponible
 */
export const hasPhone = (phone) => {
  return phone && phone.trim() !== '';
};

/**
 * Formate un objet utilisateur/customer pour l'affichage du téléphone
 * @param {Object} entity - L'objet utilisateur ou customer
 * @param {string} fallbackText - Texte de fallback
 * @returns {string} - Le téléphone formaté
 */
export const formatEntityPhone = (entity, fallbackText = 'Non renseigné') => {
  if (!entity) return fallbackText;
  
  return formatPhoneDisplay(
    entity.phone, 
    entity.phonePrefix, 
    '+33', 
    fallbackText
  );
};